<!--
 * @Description:
 * @Author: KING
 * @Date: 2022-04-02 09:32:57
 * @LastEditors: lgg
 * @LastEditTime: 2022-04-22 16:45:07
-->
<template>
  <div style="text-align: center">
    <img src="../../assets/images/tipsError.png" />
    <p style="color: #e2210f; margin-top: 0px">提交失败</p>
    <!-- <div v-if="dataList&&dataList.length>0" class="stepDiv"> -->
    <el-table :data="dataList" style="width: 100%" height="500">
      <el-table-column prop="formName" label="表单名称" width="180"> </el-table-column>
      <el-table-column prop="columnName" label="字段名称" width="180"> </el-table-column>
      <el-table-column prop="message" label="错误提示"> </el-table-column>
    </el-table>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'tipsErrorView',
  components: {},
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      timer: '',
      timeNum: 10
    };
  },

  computed: {},

  created() {
    // this.createInterval();
  },
  beforeDestroy() {
    if (this.timer) {
      // clearInterval(this.timer);
    }
  },
  methods: {
    createInterval() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timeNum = 10;
      this.timer = setInterval(() => {
        this.timeNum--;
        if (this.timeNum <= 0) {
          this.$store.commit('visitedPathDelete', this.$route.fullPath);
          history.go(-1);
        }
      }, 1000);
    },
    goBack() {
      // this.$store.commit('visitedPathDelete', this.$route.fullPath);
      // clearInterval(this.timer);
      this.$emit('closeTips', false);
    }
  }
};
</script>

<style>
.el-step__description.is-process {
  color: #303133;
  font-size: 15px;
}

.el-step__description.is-wait {
  color: #ccc1c0;
  font-size: 15px;
}

.titleDiv {
  width: 100px;
}

.stepDiv {
  width: 500px;
  max-height: 120px;
  display: flex;
  margin: 0 auto;
}

.messDiv {
  width: 400px;
  overflow: auto;
}
</style>
